const status = {
  1: "Active",
  2: "Inactive",
  3: "Pending",
};

const statusByName = {
  Active: 1,
  Inactive: 2,
  Pending: 3,
};

module.exports = { status, statusByName };
